import type { Facing } from '../anim'

/** Patrolling monster, same flat style as the skater. Authored facing right in a 32×32 box. */
export function Yeti({
  facing = 'right',
  className = '',
}: {
  facing?: Facing
  className?: string
}) {
  return (
    <span className={`inline-block aspect-square shrink-0 ${className}`}>
      <svg viewBox="0 0 32 32" className="size-full" aria-hidden>
        <ellipse cx="16" cy="30" rx="9" ry="1.6" fill="var(--skater-line)" opacity=".18" />
        <g transform={facing === 'left' ? 'translate(32 0) scale(-1 1)' : undefined}>
          {/* fur body with tufts */}
          <path
            d="M6 20 C5 12 9 5 16 5 C23 5 27 12 26 20 C25.5 26 22 29 16 29 C10 29 6.5 26 6 20 Z"
            fill="var(--yeti-fur)"
            stroke="var(--yeti-fur-shade)"
            strokeWidth="1.2"
          />
          <path d="M10 6.5 L12 3 L13.5 6 L16 2.5 L18.5 6 L20 3 L22 6.5" fill="var(--yeti-fur)" />
          <ellipse cx="16" cy="24" rx="6.5" ry="4" fill="var(--yeti-fur-shade)" opacity=".5" />
          {/* horns */}
          <path d="M8 9 L5 4 L10 7 Z M24 9 L27 4 L22 7 Z" fill="var(--ice-rock-shade)" />
          {/* face */}
          <ellipse cx="17" cy="14.5" rx="7" ry="6" fill="var(--yeti-face)" />
          <circle cx="14.5" cy="13.5" r="1.3" fill="var(--skater-line)" />
          <circle cx="20" cy="13.5" r="1.3" fill="var(--skater-line)" />
          <path
            d="M12.5 11.2 L16 12.4 M22 11.2 L18.5 12.4"
            stroke="var(--skater-line)"
            strokeWidth="1.1"
            strokeLinecap="round"
          />
          <path d="M13.5 17.5 Q17 20.5 21 17.5" fill="var(--skater-line)" />
          <rect x="15" y="17.6" width="1.6" height="2" fill="var(--yeti-fur)" />
          <rect x="18.4" y="17.6" width="1.6" height="2" fill="var(--yeti-fur)" />
          {/* feet */}
          <ellipse cx="11.5" cy="29" rx="3.5" ry="1.8" fill="var(--yeti-face)" />
          <ellipse cx="20.5" cy="29" rx="3.5" ry="1.8" fill="var(--yeti-face)" />
        </g>
      </svg>
    </span>
  )
}
